import { CacheData, Dictionary } from "@wikia/instant-config-loader";

const KEY_SEPARATOR = "|";
const VALUE_SEPARATOR = ":";
const CACHE_LENGTH_LIMIT = 5;

function mapCacheKeys(cache: Dictionary<CacheData>) {
  return (key: string) => {
    const { name, group, limit, result } = cache[key];
    return `${name}_${group}_${limit}:${result}`;
  };
}

function parseCacheDictionary(cache): Dictionary<CacheData> {
  const [key, value] = cache.split(VALUE_SEPARATOR);
  const result = value === "true";
  const [name, group, limit_string] = key.split("_");
  const limit = parseFloat(limit_string) || undefined;

  return { [name]: { name, group, limit, result, withCookie: true } };
}

export function serializeCache(cache: Dictionary<CacheData>): string {
  return Object.keys(cache)
    .slice(0, CACHE_LENGTH_LIMIT)
    .map(mapCacheKeys(cache))
    .join(KEY_SEPARATOR);
}

export function deserializeCache(cache: string): Dictionary<CacheData> {
  if (cache === "" || typeof cache !== "string") return {};

  return cache
    .split(KEY_SEPARATOR)
    .reduce(
      (serialized, obj) => ({ ...serialized, ...parseCacheDictionary(obj) }),
      {},
    );
}
